import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Form from 'flarum/common/components/Form';
import Button from 'flarum/common/components/Button';
import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
import Switch from 'flarum/common/components/Switch';
export default class HandleSpammerModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "user", void 0);
    _defineProperty(this, "hardDeleteUser", void 0);
    _defineProperty(this, "hardDeleteDiscussions", void 0);
    _defineProperty(this, "hardDeletePosts", void 0);
    _defineProperty(this, "moveDiscussionsToQuarantine", void 0);
    _defineProperty(this, "reportToSfs", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.user = this.attrs.user;
    const antiSpamData = app.forum.attribute('fof-anti-spam');
    const defaultActions = antiSpamData['default-options'];
    this.hardDeleteUser = defaultActions['deleteUser'];
    this.hardDeleteDiscussions = defaultActions['deleteDiscussions'];
    this.hardDeletePosts = defaultActions['deletePosts'];
    this.moveDiscussionsToQuarantine = defaultActions['spamQuarantine'];
    this.reportToSfs = defaultActions['reportToSfs'];
  }
  className() {
    return 'HandleSpammerModal Modal--medium';
  }
  title() {
    return app.translator.trans('fof-anti-spam.forum.spammer_modal.title', {
      username: this.user.displayName()
    });
  }
  content() {
    var _sfs$canReport;
    const tagsEnabled = app.initializers.has('flarum-tags');
    const antiSpamData = app.forum.attribute('fof-anti-spam');
    const sfs = antiSpamData['stopforumspam'];
    // Reporting is what needs an API key; looking spammers up never did.
    const sfsEnabled = !!((_sfs$canReport = sfs == null ? void 0 : sfs['canReport']) != null ? _sfs$canReport : sfs == null ? void 0 : sfs['enabled']);
    return m("div", {
      className: "Modal-body"
    }, m(Form, null, m("p", {
      className: "helpText"
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.intro')), m("div", {
      className: "Form-group"
    }, m(Switch, {
      state: this.hardDeleteDiscussions,
      onchange: value => {
        this.hardDeleteDiscussions = value;
        m.redraw();
      }
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.hard_delete_discussions_label')), m("p", {
      className: "helpText"
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.hard_delete_discussions_help'))), m("div", {
      className: "Form-group"
    }, m(Switch, {
      state: this.hardDeletePosts,
      onchange: value => {
        this.hardDeletePosts = value;
      }
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.hard_delete_posts_label')), m("p", {
      className: "helpText"
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.hard_delete_posts_help'))), tagsEnabled && !this.hardDeleteDiscussions && m("div", {
      className: "Form-group"
    }, m(Switch, {
      state: this.moveDiscussionsToQuarantine,
      onchange: value => {
        this.moveDiscussionsToQuarantine = value;
      }
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.move_discussions_tag_label')), m("p", {
      className: "helpText"
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.move_discussions_tag_help'))), m("div", {
      className: "Form-group"
    }, m(Switch, {
      state: this.hardDeleteUser,
      onchange: value => {
        this.hardDeleteUser = value;
      }
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.hard_delete_user_label')), m("p", {
      className: "helpText"
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.hard_delete_user_help'))), sfsEnabled && m("div", {
      className: "Form-group"
    }, m(Switch, {
      state: this.reportToSfs,
      onchange: value => {
        this.reportToSfs = value;
      }
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.report_to_sfs_label')), m("p", {
      className: "helpText"
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.report_to_sfs_help'))), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.submitData(),
      loading: this.loading,
      disabled: this.loading
    }, app.translator.trans('fof-anti-spam.forum.spammer_modal.process_button')))));
  }
  submitData() {
    this.loading = true;
    const body = {
      options: {
        deletePosts: this.hardDeletePosts,
        deleteDiscussions: this.hardDeleteDiscussions,
        deleteUser: this.hardDeleteUser,
        moveDiscussionsToQuarantine: this.moveDiscussionsToQuarantine,
        reportToSfs: this.reportToSfs
      }
    };
    app.request({
      method: 'POST',
      url: "".concat(app.forum.attribute('apiUrl'), "/users/").concat(this.user.id(), "/spamblock"),
      body: body
    }).then(() => {
      this.loading = false;
      this.hide();
    });
  }
}
flarum.reg.add('fof-anti-spam', 'forum/components/HandleSpammerModal', HandleSpammerModal);